import { ReactNode } from 'react'
import { IntroStep } from '../IntroDuction/IntroStep'
import { FirstStep } from '../IntroDuction/FirstStep'
import { SecondStep } from '../IntroDuction/SecondStep'
import { ThirdStep } from '../IntroDuction/ThirdStep'
import { FourthStep } from '../IntroDuction/ForthStep'
import { Finish } from '../IntroDuction/FinishStep'

export type StepContents = Readonly<{ label: string; content: ReactNode }>[]

export type ConnectFacebookDialogStepKind = 'intro' | 1 | 2 | 3 | 4 | 5

export const connectFacebookDialogSteps: Readonly<{
  [key in ConnectFacebookDialogStepKind]: {
    title: string
    content: ReactNode
  }
}> = {
  intro: {
    title: 'Facebookアカウントをtoridori marketingと連携する',
    content: <IntroStep />,
  },
  1: {
    title: 'Facebookアカウントを作成する',
    content: <FirstStep />,
  },
  2: {
    title: 'Instagramアカウントを作成する',
    content: <SecondStep />,
  },
  3: {
    title: 'Instagramアカウントをプロアカウントに変更する',
    content: <ThirdStep />,
  },
  4: {
    title: 'Facebookページを作成・Instagramアカウントと連携する',
    content: <FourthStep />,
  },
  5: {
    title: 'toridori marketingとInstagramアカウントを連携する',
    // 一番肝心な部分
    content: <Finish />,
  },
} as const
